import { IconProps } from "../../types/genereal";
import { IconWrapper } from "../ui/IconWrapper";

export const CheckIcon = ({
  width = "24",
  height = "24",
  color = "#27AE60",
}: IconProps) => {
  return (
    <IconWrapper width={width} height={height}>
      <svg
        width={width}
        height={height}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M18.3599 6.35986L10.1999 14.5199L6.83991 11.1599L5.15991 12.8399L10.1999 17.8799L20.0399 8.03986L18.3599 6.35986Z"
          fill={color}
        />
      </svg>
    </IconWrapper>
  );
};
